import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface PageTranslation {
  Page_id?: ID;
  _id?:ID
  language: string;
  title: string;
  metaTitle: string,
  metaDescription: string,
  metaKeywords: string[],
  openGraphType:string,
  openGraphTitle: string,
  openGraphDescription: string,
  openGraphImage: string,
  twitterTitle: string,
  twitterDescription: string,
  twitterImage: string
}

export interface Page {
  _id?: ID;
  translations: PageTranslation[];
  title:String;
  slug:String

 
}
export interface SectionTranslation {
  _id?:ID
  language: string;
  title: string;
  subtitle?: string,
  content?: string,

}
export interface Section {
  _id?: ID;
  translations: SectionTranslation[];
  title:String;
  position:Number;
  image?: string;
  time?: string;
  attributes: Array<{
    type: 'image' | 'text' | 'button' | 'long-text'
    key: string
    image?: {
      url: string
      seoUrl: string
    }
    translations?: Array<{
      language: string
      value: string
    }>
  }>
}

export const initialPage: Page = {
  title:'',
  slug:'',
  translations: [
    {
 
      language: '',
      title:"",
      metaTitle:'',
      metaDescription: '',
      metaKeywords: [],
      openGraphType:'',
      openGraphTitle: '',
      openGraphDescription: '',
      openGraphImage: '',
      twitterTitle: '',
      twitterDescription: '',
      twitterImage: ''
      
    },
  ],
};
export type PagesQueryResponse = Response<Array<Page>>;
export type QueryResponsePageContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createPageResponseContext<T>(initialState: QueryResponsePageContextProps<T>) {
  return createContext(initialState)
}
export const initialPageQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }